'use strict';

window.actionTrackings = window.actionTrackings || [];
var stj = typeof stj !== 'undefined' ? stj : {};

stj.add2hs = {
    TRACKING_PREFIX: 'add_to_homescreen',
    PLATFORM_TRACKING_PREFIX: 'add_to_homescreen_platform',
    APP_INSTALL_POSSIBLE_TRACKING: 'possible',
    APP_INSTALLED_TRACKING: 'installed',
    APP_BUTTON_TRACKING: 'by_button',

    installPromptEvent: null,

    setAddToHomeScreenEvents: function () {
        window.addEventListener(
            'beforeinstallprompt',
            function (event) {
                if (!event) {
                    return;
                }
                this.installPromptEvent = event;
                this.setInstallPromptEvent();
                this.trackDeviceMetrics(
                    this.PLATFORM_TRACKING_PREFIX,
                    event.platforms.join(',')
                );
                this.trackDeviceMetrics(
                    this.TRACKING_PREFIX,
                    this.APP_INSTALL_POSSIBLE_TRACKING
                );
            }.bind(this)
        );

        window.addEventListener(
            'appinstalled',
            function () {
                this.trackAddToHomescreen(this.APP_INSTALLED_TRACKING);
            }.bind(this)
        );

        this.fixIosStandalone();
    },

    setInstallPromptEvent: function () {
        this.installPromptEvent.userChoice.then(
            function (choice) {
                this.trackAddToHomescreen(choice.outcome || choice);
                this.installPromptEvent = null;
            }.bind(this)
        );
    },

    trackDeviceMetrics: function (key, value) {
        if (typeof newrelic !== 'object') {
            return;
        }
        newrelic.setCustomAttribute(key, value);
    },

    trackAddToHomescreen: function (label) {
        window.actionTrackings.push({
            acTrAc: this.TRACKING_PREFIX,
            acTrLa: label,
        });
    },

    /**
     * @see https://stanhub.com/how-to-prevent-ios-standalone-mode-web-apps-from-opening-links-in-safari/
     */
    fixIosStandalone: function () {
        if ('standalone' in window.navigator && window.navigator.standalone) {
            this.trackDeviceMetrics(
                this.TRACKING_PREFIX,
                this.APP_INSTALL_POSSIBLE_TRACKING
            );
            this.trackAddToHomescreen(this.APP_INSTALLED_TRACKING);
            document.addEventListener(
                'click',
                function (event) {
                    if (!event || !event.target) {
                        return;
                    }

                    var clickTargetNode = event.target;

                    while (
                        clickTargetNode.nodeName !== 'A' &&
                        clickTargetNode.nodeName !== 'HTML'
                    ) {
                        clickTargetNode = clickTargetNode.parentNode;
                    }

                    if (
                        'href' in clickTargetNode &&
                        clickTargetNode.href.indexOf('http') !== -1 &&
                        clickTargetNode.href.indexOf(document.location.host) !==
                            -1
                    ) {
                        event.preventDefault();
                        document.location.href = clickTargetNode.href;
                    }
                },
                false
            );
        }
    },
};

window.addEventListener('load', function () {
    stj.add2hs.setAddToHomeScreenEvents();
});
